@if (items().length > 0) {
  <lib-breadcrumb [items]="items()" />
}
